// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-section {
    width: 80%;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
  }
  
  .header-section {
    flex: 0.2 1;
    margin-bottom: 32px;
  }
  
  .page-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  
  .form-row {
    display: flex;
    gap: 16px;
  }
  
  .input-container {
    flex: 1 1;
    position: relative;
  }
  
  .patient-input {
    width: 40%;
    padding: 8px 16px;
    padding-left: 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
  }
  
  .input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    color: #9ca3af;
  }
  
  .submit-button {
    padding: 8px 16px;
    background-color: #0d9488;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
  }
  
  .submit-button:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
  
  .active-component {
    border: 2px dashed #e5e7eb;
    border-radius: 8px;
    flex: 0.8 1;
    
  }
  
  
  
  
  /* DashboardRightSection */
  
  
  .select-container {
    position: absolute; 
    left: 750px; 
    width: 192px; 
  }
  
  .visit-select {
    width: 100%;
    padding: 8px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    appearance: none;
    background-color: white;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 12px center;
    background-repeat: no-repeat;
    background-size: 20px;
    font-size: 14px;
    left: 100px;
  }
  
  .transcript-section {
    margin-bottom: 24px;
  }
  
  .transcript-title {
    font-size: 18px;
    font-weight: 500;
    border-bottom: 2px solid #0d9488;
    display: inline-block;
    padding-bottom: 8px;
  }
  
  /* Add these styles to your existing CSS file */
  
  .recording-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #ffffff;
  }
  
  .recording-active {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
  }
  
  .stop-recording-btn {
    background-color: #dc2626;
    color: white;
    border: none;
    border-radius: 24px;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s;
  }
  
  .stop-recording-btn:hover {
    background-color: #b91c1c;
  }
  .record-btn,
.stop-recording-btn,
.pause-recording-btn,
.resume-recording-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 16px;
}
  
  .pause-icon {
    width: 20px;
    height: 20px;
  }
  
  .recording-status {
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 16px;
    min-width: 200px;
  }
  
  .timer-container {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .mic-icon {
    width: 20px;
    height: 20px;
    color: #0d9488;
  }
  
  .timer {
    font-size: 16px;
    font-weight: 500;
    color: #374151;
  }
  
  .waveform {
    margin-left: 8px;
  }
  
  .recording-message {
    text-align: center;
  }
  
  .recording-message h3 {
    font-size: 18px;
    color: #374151;
    margin-bottom: 8px;
  }
  
  .recording-message p {
    color: #6b7280;
    font-size: 14px;
  }
  
  /* Existing styles */
  .aint {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .record-btn {
    background-color: #0d9488;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-bottom: 16px;
    justify-content: center;
  }
  
  .record-icon {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
  }
  
  .recording-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  .recording-text {
    color: #6b7280;
  }
  
  .upload-btn {
    color: #0d9488;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font: inherit;
  }
  
  
  .patient-name {
    font-size: 16px;
    font-weight: 500;
    color: #111827;
    margin: 0;
  }
  
  .aint {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  
  
  @media (max-width: 1024px) {
    .right-section {
      width: 75%;
      padding: 16px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/dashboardRightSectionComponent/RecordingandUploading.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,WAAS;;EAEX;;;;;EAKA,0BAA0B;;;EAG1B;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,yDAAmP;IACnP,sCAAsC;IACtC,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,+CAA+C;;EAE/C;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;EACA;;;;EAIA,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;EACf;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;;;EAIA;IACE;MACE,UAAU;MACV,aAAa;IACf;EACF","sourcesContent":[".right-section {\r\n    width: 80%;\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 24px;\r\n  }\r\n  \r\n  .header-section {\r\n    flex: 0.2;\r\n    margin-bottom: 32px;\r\n  }\r\n  \r\n  .page-title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .form-row {\r\n    display: flex;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .input-container {\r\n    flex: 1;\r\n    position: relative;\r\n  }\r\n  \r\n  .patient-input {\r\n    width: 40%;\r\n    padding: 8px 16px;\r\n    padding-left: 40px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .input-icon {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 20px;\r\n    height: 20px;\r\n    color: #9ca3af;\r\n  }\r\n  \r\n  .submit-button {\r\n    padding: 8px 16px;\r\n    background-color: #0d9488;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .submit-button:disabled {\r\n    background-color: #9ca3af;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .active-component {\r\n    border: 2px dashed #e5e7eb;\r\n    border-radius: 8px;\r\n    flex: 0.8;\r\n    \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  /* DashboardRightSection */\r\n  \r\n  \r\n  .select-container {\r\n    position: absolute; \r\n    left: 750px; \r\n    width: 192px; \r\n  }\r\n  \r\n  .visit-select {\r\n    width: 100%;\r\n    padding: 8px 16px;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    appearance: none;\r\n    background-color: white;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\r\n    background-position: right 12px center;\r\n    background-repeat: no-repeat;\r\n    background-size: 20px;\r\n    font-size: 14px;\r\n    left: 100px;\r\n  }\r\n  \r\n  .transcript-section {\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  .transcript-title {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    border-bottom: 2px solid #0d9488;\r\n    display: inline-block;\r\n    padding-bottom: 8px;\r\n  }\r\n  \r\n  /* Add these styles to your existing CSS file */\r\n  \r\n  .recording-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    background-color: #ffffff;\r\n  }\r\n  \r\n  .recording-active {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .stop-recording-btn {\r\n    background-color: #dc2626;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 24px;\r\n    padding: 12px 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .stop-recording-btn:hover {\r\n    background-color: #b91c1c;\r\n  }\r\n  .record-btn,\r\n.stop-recording-btn,\r\n.pause-recording-btn,\r\n.resume-recording-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  margin-bottom: 16px;\r\n}\r\n  \r\n  .pause-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .recording-status {\r\n    background-color: white;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 8px 16px;\r\n    min-width: 200px;\r\n  }\r\n  \r\n  .timer-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .mic-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    color: #0d9488;\r\n  }\r\n  \r\n  .timer {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #374151;\r\n  }\r\n  \r\n  .waveform {\r\n    margin-left: 8px;\r\n  }\r\n  \r\n  .recording-message {\r\n    text-align: center;\r\n  }\r\n  \r\n  .recording-message h3 {\r\n    font-size: 18px;\r\n    color: #374151;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .recording-message p {\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Existing styles */\r\n  .aint {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .record-btn {\r\n    background-color: #0d9488;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 8px 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    cursor: pointer;\r\n    margin-bottom: 16px;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .record-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .recording-title {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .recording-text {\r\n    color: #6b7280;\r\n  }\r\n  \r\n  .upload-btn {\r\n    color: #0d9488;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    font: inherit;\r\n  }\r\n  \r\n  \r\n  .patient-name {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #111827;\r\n    margin: 0;\r\n  }\r\n  \r\n  .aint {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n  \r\n  \r\n  \r\n  @media (max-width: 1024px) {\r\n    .right-section {\r\n      width: 75%;\r\n      padding: 16px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
